

export const convert = (passedDate) => {
    return {
        fullDate: new Date(passedDate).toLocaleString("en-US", { month: "short", year: "numeric" }),
        year: new Date(passedDate).getFullYear(),
        month: new Date(passedDate).toLocaleString("en-US", { month: "short" }),

    }
}

export const dayOnly = { weekday: "short" };
export const dayOfMonth = { month: 'short', day: 'numeric' };

export const allNumeric = { month: 'numeric', day: 'numeric',  year: "numeric" };

